import {
  Box,
  Button,
  Center,
  Container,
  Divider,
  Flex,
  SimpleGrid,
  Spacer,
  Text,
} from "@chakra-ui/react";
import InfiniteScroll from "react-infinite-scroller";
import { useInfiniteQuery, useQuery } from "react-query";
import { Link, useNavigate, useParams } from "react-router-dom";

import { EditIcon } from "@chakra-ui/icons";
import {
  getComics,
  getMySingleReadingOrder,
} from "../../../services/readingOrdersApi";
import Spinner from "../../../shared/components/Spinner";
import ReadingOrderHeader from "../../reading/components/ReadingOrderHeader";
import AuthorFooter from "../../browse/components/AuthorFooter";
import MyReadingOrderSharing from "../components/MyReadingOrderSharing";

const MyOrdersView = () => {
  let comics = [];
  const { readingOrderId } = useParams();
  const navigate = useNavigate();
  const readingOrderQuery = useQuery(["readingOrder", readingOrderId], () => {
    return getMySingleReadingOrder(readingOrderId);
  });
  const comicsQuery = useInfiniteQuery(
    ["orderComics", readingOrderId],
    ({ pageParam = 1 }) => getComics(readingOrderId, pageParam),
    {
      keepPreviousData: true,
      getNextPageParam: (pageParam, allPages) => {
        if (pageParam?.meta.currentPage === pageParam?.meta.lastPage) {
          return undefined;
        }
        return pageParam?.meta?.currentPage + 1;
      },
    }
  );

  const uniqBy = (theArray) => {
    var seen = {};
    return theArray.filter((item) => {
      var k = `${item.id}-${item?.story}`;
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
  };

  if (readingOrderQuery.isLoading) {
    return <Spinner />;
  }

  const readingOrder = readingOrderQuery.data.data;

  if (comicsQuery.data) {
    comics = uniqBy(
      [...comicsQuery?.data?.pages?.flatMap((group, i) => group.data)].sort(
        (a, b) => a.order - b.order
      )
    );
  }

  return (
    <Container maxW="container.lg">
      <SimpleGrid mt="6" columns={{ sm: 1, md: 1, lg: 2 }} spacing={2}>
        <Box>
          <Box bg="gray.700" borderRadius="lg">
            <Box position="relative">
              <Button
                as={Link}
                to={`/my-orders/${readingOrder.id}/edit`}
                leftIcon={<EditIcon />}
                variant="solid"
                size="xs"
                position="absolute"
                bottom={0}
                right={0}
                zIndex={100}
                mr="3"
                mb="4"
              >
                Edit
              </Button>
              <ReadingOrderHeader
                totalComics={readingOrder.comicsCount}
                readingOrder={readingOrder}
                hideProgress
                showFranchise
              />
            </Box>

            {!!readingOrder?.description && (
              <Box p="6">
                <Text fontSize="sm">{readingOrder?.description}</Text>
              </Box>
            )}

            {!!readingOrder?.description &&
              !!readingOrder.author &&
              !!readingOrder?.privacyMode && (
                <Box px="6">
                  <Divider />
                </Box>
              )}
            {!!readingOrder?.author && !!readingOrder?.privacyMode && (
              <AuthorFooter readingOrder={readingOrder} />
            )}
          </Box>

          <MyReadingOrderSharing readingOrder={readingOrder} />
        </Box>
        <Box bg="gray.700" borderRadius="lg">
          <Flex p="3" borderBottomColor="gray.900" borderBottomWidth="1px">
            <Text fontSize="sm" color="gray.400" mt="2" ml="1">
              READING ORDER
            </Text>
            <Spacer />
            <Button
              as={Link}
              size="sm"
              type="submit"
              to={`/my-orders/${readingOrderId}/edit-order`}
            >
              Edit order
            </Button>
          </Flex>
          {/* Reading order list */}
          {comicsQuery.isLoading ? (
            <Spinner />
          ) : (
            <div
              className="List"
              style={{
                width: `100%`,
                height: `75vh`,
                overflow: "auto",
              }}
            >
              <InfiniteScroll
                pageStart={1}
                loadMore={() => {
                  if (!comicsQuery.isFetchingNextPage) {
                    comicsQuery.fetchNextPage();
                  }
                }}
                height="75vh"
                useWindow={false}
                hasMore={comicsQuery.hasNextPage}
                loader={
                  <Center key="loader">
                    <Link size="sm" variant="outline" w="96%">
                      Loading more issues...
                    </Link>
                  </Center>
                }
              >
                {comics.map((comic, index) => (
                  <Flex
                    justifyContent="space-between"
                    alignItems="center"
                    py="3"
                    borderBottomWidth="1px"
                    borderBottomColor="gray.900"
                    borderLeftWidth={"5px"}
                    borderLeftColor={"transparent"}
                    key={`${comic.id}-${index}`}
                  >
                    <Box px="3">{comic.order}.</Box>
                    <Box flexGrow={2}>
                      <Text
                        fontSize="0.9em"
                        lineHeight="1.25em"
                        overflowWrap="break-word"
                        wordBreak="break-word"
                        cursor="pointer"
                        onClick={() =>
                          navigate(`/comics/${comic.id}/view`, {
                            state: { comic: comic },
                          })
                        }
                      >
                        {comic.title} {comic.story && `[${comic.story}]`}
                      </Text>
                    </Box>
                  </Flex>
                ))}
              </InfiniteScroll>
            </div>
          )}
        </Box>
      </SimpleGrid>
    </Container>
  );
};

export default MyOrdersView;
